import { render } from "./SidenavTree.vue?vue&type=template&id=6499b235"
import script from "./SidenavTree.vue?vue&type=script&lang=js"
export * from "./SidenavTree.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fahrezibayuprabowo/Documents/project/accessories-cellular-frontend-dev-muped/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__